import axios from "axios";
//创建axios实例
const instance = axios.create();
//设置超时时间
instance.defaults.timeout = 30000;
//带上请求身份凭证cookie(解决跨域的时候没有携带cookie的问题)
instance.defaults.withCredentials = true;
//请求拦截器
instance.interceptors.request.use(function (config) {
  //发送请求前做些什么
  config.url = process.env.BASE_URL + config.url;//加上当前根路径，有可能为虚拟目录
  return config;
}, function (error) {
  //对请求错误做些什么
  return Promise.reject(error);
});
//请求响应拦截器
instance.interceptors.response.use(function (res) {
  //成功
  if (res.status === 200) {
    return Promise.resolve(res.data);
  } else {
    Promise.reject(res);
  }
}, function (error) {
  //失败
  const { response } = error;
  if (response) {
    //请求已发出，失败
    return Promise.reject(response)
  }
});
export default instance;